import { ethers } from "ethers";
import ERC20 from "../abi/ERC20.json";

export async function getTokenInfo(tokenAddress) {
  
    const networks = [
        { name: "Ethereum", url: process.env.REACT_APP_ETHEREUM_MAINNET },
        { name: "Base", url: process.env.REACT_APP_BASE_MAINNET },
        { name: "Binance Smart Chain", url: process.env.REACT_APP_BSC_MAINNET },
        { name: "Avalanche", url: process.env.REACT_APP_AVALANCHE_MAINNET },
    ];
 
    const results = await Promise.all(
        networks.map(async (network) => {
            try {
                const provider = new ethers.providers.JsonRpcProvider(network.url);
                const tokenContract = new ethers.Contract(tokenAddress, ERC20.abi, provider);
  
                const name = await tokenContract.name();
                const symbol = await tokenContract.symbol();
                const decimals = await tokenContract.decimals();

                return {
                    network: network.name,
                    address: tokenAddress,
                    name,
                    symbol,
                    decimals,
                    icon: null
                };
            } catch (error) { 
                return null;
            }
        })
    );
 
    return results.filter((result) => result !== null);
}
